import React, { useEffect } from 'react';
import { ModalBody } from 'reactstrap'
import { StyledModal, Container } from './styles'
import Button from 'components/Button'

const ModalMain = ({
  isOpen,
  setIsOpen,
  setClose,
  className,
  children,
  additionalstyle,
  danger,
  success,
  buttonIcon,
  iconStyle,
  buttonLabel,
  buttonStyle,
  hidden,
  cleanFunction
}) => {

  const openModal = () => {
    if(setIsOpen) {
      setIsOpen(true)
    }
  }

  const closeModal = React.useCallback(() => {
    if(cleanFunction) {
      cleanFunction()
    }
    if(setClose) {
      setClose()
    } else if(setIsOpen) {
      setIsOpen(false)
    }
  }, [cleanFunction, setClose, setIsOpen]);

  useEffect(() => {
    if (!isOpen) return; // Only activate if modal is open

    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => document.removeEventListener('keydown', handleEscKey);
  }, [isOpen, closeModal]); 

  return (
    <Container
      hidden={hidden}
      iconStyle={iconStyle}
    >
      {buttonLabel? (
        <Button
          mainPage
          danger={danger}
          success={success}
          hidden={!buttonLabel}
          onClick={openModal}
          additionalstyle={buttonStyle}
        >
          {buttonLabel}
        </Button>
      ) : buttonIcon? (
        <div
          className="icon"
          onClick={openModal}
          
        >  
          {buttonIcon}
        </div>
      ): null}
      <StyledModal
        isOpen={isOpen}
        className={className}
        additionalstyle={additionalstyle}
      >
        {(setIsOpen || setClose)? <div className="close" onClick={closeModal} />: null}
        <ModalBody>{children}</ModalBody>
      </StyledModal>
    </Container>
  );
};

export default ModalMain;
